export default {
	bind(el, binding, vnode) {
		// 监听drawer打开事件
		vnode.componentInstance.$on('open', () => {
			// 隐藏遮罩层
			const overlay = document.querySelector('.el-overlay');
			if (overlay) {
				overlay.style.display = 'none';
			}

			// 允许页面滚动
			document.body.style.overflow = 'auto';
		});

		vnode.componentInstance.$on('close', () => {
			// 恢复页面滚动
			document.body.style.overflow = '';
		});
	}
};
